{
  "validation": {
    "required": "Обов'язкове поле",
    "name": {
      "lettersOnly": "Імʼя має містити тільки літери"
    },
    "email": {
      "invalidFormat": "Неправильний формат"
    },
    "phone": {
      "invalidFormat": "Неправильний формат"
    },
    "password": {
      "minLength": "Повинен мати 8 символів і містити 1 велику та 1 малу літеру.",
      "mismatch": "Паролі не співпадають"
    },
    "birthday": {
      "maxDate": "Дата не може бути більше ніж сьогоднішня дата"
    }
  },

  "ui": {
    "error": {
      "invalidLink": "Такого посилання не існує",
      "inactiveLink": "Неактивне посилання, його вже використали, або воно було деактивовано",
      "isRegistered": "Якщо ви вже зареєстрували акаунт, перейдіть до особистого кабінету за цим посиланням"
    },
    "form": {
      "title": "Створити мій профіль:",

      "username": {
        "label": "Як до вас звертатись?",
        "placeholder": "Наприклад, Олександра"
      },
      "phone": {
        "label": "Телефон",
        "placeholder": "+380__ ___ ____"
      },
      "birthday": {
        "label": "Дата народження"
      },
      "email": {
        "label": "Електронна пошта",
        "placeholder": "maill@mail.zz"
      },
      "password": {
        "label": "Пароль",
        "placeholder": "Створіть пароль",
        "message": "Мінімум 8 символів, одна велика і одна мала літера"
      },
      "passwordConfirm": {
        "label": "Повторити пароль",
        "placeholder": "Ще раз для підтвердження"
      },
      "termsAndConditions": {
        "agree": "Я погоджуюсь з ",
        "desc": "Умовами використання"
      },
      "privacyPolicy": {
        "agree": "Я ознайомився(-лась) з ",
        "desc": "Повідомленням про обробку даних"
      },
      "actions": {
        "submit": {
          "label": "Створити і продовжити",
          "loading": "Реєструємо"
        },
        "back": "Назад"
      },
      "orSeparator": "Aбо"
    },
    "auth": {
      "alreadyHaveAccount": "Вже маєте акаунт?",
      "login": "Увійти"
    }
  }
}
